import React, {memo, useState, useEffect} from 'react'
import cx from 'classnames'

/* Hooks */
import {useEffectOnlyOnUpdate} from '../../../../common/react/hook/lifecycle'

/* Components */
import VoltranFragment from '../../../../components/VoltranFragment/VoltranFragment'
import HorizontalProductsSkeleton from '../../../../components/HorizontalProductsSkeleton/HorizontalProductsSkeleton'

/* Styles */
import s from './sponsoredProducts.scss'

const SponsoredProducts = memo(({
  className,
  fragmentInfo,
  options,
  sku
}) => {
  const [sponsoredProductStatus, setSponsoredProductStatus] = useState()

  useEffect(() => {
    window.HbEventBus.on('hepsiads.productDetail.sponsorProducts', (data) => {
      setSponsoredProductStatus(data)
    })
  }, [])

  useEffectOnlyOnUpdate(() => {
    setSponsoredProductStatus()
    window.HbEventBus.emit('storefront.voltran.sponProduct-basket.rerender', {
      sku
    })
  }, [sku])

  return (
    <div
      className={cx(s.root, className, {[s.hidden]: typeof sponsoredProductStatus === 'boolean' && !sponsoredProductStatus})}
      data-test-id={'sponsored-products'}>
      {
        typeof sponsoredProductStatus === 'undefined' &&
        <HorizontalProductsSkeleton className={s.skeleton} cardClassName={s.placeholderCard} cardCount={7}/>
      }
      {
        fragmentInfo &&
        <VoltranFragment
          fragmentInfo={fragmentInfo}
          options={options}
          renderMethodClientSide={process.env.BROWSER}
          removeClientStyles
        />
      }
    </div>
  )
})

export default SponsoredProducts
